import DumpDataService from "../../services/DumpData.Service";
import GlobalService from "../../services/GlobalService";
import { getPartnerAddress, isPartnerChannelCode } from "../../shared/PartnerUtility";
import { SetTokenValues } from "../../shared/SharedUtility";
import { getScreen, getSSLData, getUserDetails } from "../../shared/TrackRetUtility";
import { getAddress, getTrackState, getVisionAddress } from "../../shared/utility";
import * as types from "../types";
import { funcUpdateAppStateAfterResponse } from "./AppStateActions";
import { funcStoreMultiUrl, funcStoreVisionAddress } from "./SslActions";

const initState = {
  isSaved: true,
  currentAction: "",
  isSubmited: false,
  isSubmitedSuccess: false,
  screenName: "",
  loading: false,
  error: null,
};
let payload = {};
let errorState = {};

export const setDumpBased = (value) => (dispatch) => {
  dispatch({ type: types.SAVE_IS_DUMP_BASED, payload: value });
}

export const setDumpData = (value) => (dispatch) => {
  dispatch({type: types.SAVE_CORPORATE_DUMP_DATA , payload:value});
  dispatch({
    type: types.UPDATE_CURRENT_APP_STATE,
    payload: {
      isSaved: true,
      currentAction: "ValidateOTP",
      screenName: "corporateEmpId",
      isSubmited: false,
      isSubmitedSuccess: false,
      datafilled: false,
      loading: false,
      error: null,
    },
  });
}

export const setDumpCardTypeValOtpMain = (payload, action) => async (dispatch) => {
  payload["currentAction"] = action;
  dispatch({ type: types.LOADING_VIEW_STATE, value: true, });
  const response = await DumpDataService.funcValidateDumpOtp(payload.dumpData, payload.otpInput, payload.corpCard, action);
  if (response && response.data) {
    const statusCode = response.data.statusCode;
    if (statusCode === "000" || statusCode === "002" || statusCode === "005") {
      const dataset = response.data.data;
      var dumpFlag = response.data?.data?.dumpAppFlag === 'Y' ? true : response.data?.data?.isDumpBased === 'Y' ? true : false;
      dispatch({ type: types.SAVE_IS_DUMP_BASED, payload: dumpFlag });
      dataset["mobileNo"] = response.data.data?.mobileNumber;
      delete dataset.mobileNumber;
      if (!response.data.data?.cardType) {
        dataset['cardType'] = "";
      }
      if (dataset["state"]) {
        errorState = null;
        payload["isUserRetrieve"] = true;
        const sslData = getSSLData(response.data.data);

        dispatch({ type: types.VALIDATE_OTP_CREATE_SSL, payload: { data: sslData }, });
        if (response.data?.data?.vPlusAddress) {
          let res = {
            vPlusResiAddress: response.data?.data && response.data?.data?.vPlusAddress ? response.data?.data?.vPlusAddress : null,
            visionMothersName: response.data?.data && response.data?.data?.vPlusMotherName ? response.data?.data?.vPlusMotherName : "",
            visionEmailId: response.data?.data && response.data?.data?.vPlusEmailId ? response.data?.data?.vPlusEmailId : "",
            dSignVPlusMotherName: response.data?.data && response.data?.data?.dSignVPlusMotherName ? response.data?.data?.dSignVPlusMotherName : "",
            dSignVPlusEmailId: response.data?.data && response.data?.data?.dSignVPlusEmailId ? response.data?.data?.dSignVPlusEmailId : "",
            dSignVPlusResiAddress: response.data?.data && response.data?.data?.dSignVPlusResiAddress ? response.data?.data?.dSignVPlusResiAddress : ""
          };
          let vAddress = res.vPlusResiAddress;
          const vPlusResiAddress = getVisionAddress(vAddress);
          dispatch(funcStoreVisionAddress({ ...res, vPlusResiAddress }));
        }
        const screenDetails = getScreen(sslData);
        /**********When Lead Is NON-Consented Start**************/
        if (response.data?.data?.hasOwnProperty('consentFlag') && response.data.data.consentFlag === "N") {
          /**********When Lead Is NON-Consented End**************/
        }
        else {
          const lg_lite_partner_chanel = window.global.config?.LG_LITE_PARTNER_CHANEL;
          if (lg_lite_partner_chanel.includes(dataset['channelCode']))
            localStorage.setItem("sourceCode", "DC");
          payload = {
            ...initState,
            // isSubmited: true,
            //isSubmitedSuccess: true,
            screenName: screenDetails.goTo,
            isUserRetrieve: true,
            loading: false,
          };
        }
        dispatch({ type: types.SAVE_PERSONAL_DETAILS, payload: dataset, });
        if (response.data.data?.cardType)
          dispatch({ type: types.SAVE_NETWORK_CARDTYPE, payload: response.data.data?.cardType });
      }
      else {
        payload = { ...initState, currentAction: "ValidateOTP", isSubmitedSuccess: false, dataFilled: false, loading: false, };
        errorState = {
          errorCode: "999",
          errorMsg: "Invalid state",
          //invalidOtpAttemptCount: response.data.data?.invalidOtpAttemptCount,
        };
      }

    }
    else if (statusCode === "003") {
      const dataset = response.data.data;
      const lg_lite_partner_chanel = window.global.config?.LG_LITE_PARTNER_CHANEL;
      if (lg_lite_partner_chanel.includes(dataset['channelCode']))
        localStorage.setItem("sourceCode", "DC");
      let user = getUserDetails(response.data.data);
      if (response.data?.data?.vPlusAddress) {
        let res = {
          vPlusResiAddress: response.data?.data && response.data?.data?.vPlusAddress ? response.data?.data?.vPlusAddress : null,
          dSignVPlusResiAddress: response.data?.data && response.data?.data?.dSignVPlusResiAddress ? response.data?.data?.dSignVPlusResiAddress : ""
        };
        let vAddress = res.vPlusResiAddress;
        const vPlusResiAddress = getVisionAddress(vAddress);
        dispatch(funcStoreVisionAddress({ ...res, vPlusResiAddress }));
      }

      if (response.data.data.blazeFungibleFlag === 'Y') {
        const fungibleData = {
          fungibleFlag: response.data.data.blazeFungibleFlag,
          fungibleCurrLimit: response.data.data.fungibleCurrXpos,
          fungibleIncLimit: response.data.data.fungibleIncLimit
        }
        dispatch({ type: types.SAVE_FUNGIBLE_DATA, payload: fungibleData });
      }
      if (dataset.dumpAppFlag)
        dispatch({ type: types.SAVE_IS_DUMP_BASED, payload: dataset.dumpAppFlag === 'Y' ? true : false });

      if (response.data.data.earlyCreditDecPartner && response.data.data.earlyCreditDecPartner === 'Y') {
        dispatch({ type: types.SAVE_EARLY_CREDIT_FLAG, payload: response.data.data.earlyCreditDecPartner })
      }


      if (isPartnerChannelCode(response.data?.data?.channelCode) || (response.data.data?.earlyCreditDecPartner && response.data.data?.earlyCreditDecPartner === 'Y')) {
        dispatch({
          type: types.SAVE_PARTNER_DATA,
          payload: {
            channelCode: response.data?.data?.channelCode,
            contactDetails: getPartnerAddress(response.data?.data?.contactDetails),
            inbmitcScreen: response.data?.data?.inbmitcScreen,
            autoSweepReceived: response.data?.data?.autoSweepDetailsBO?.autoSweepReceived,
            autoDebitReceived: response.data?.data?.autoDebitDetailsBO?.autoDebitReceived,
            paymentOption: response.data?.data?.autoDebitDetailsBO?.paymentOption,
            blazeAdFlag: response.data?.data?.blazeAdFlag,
            blazeAsFlag: response.data?.data?.blazeAsFlag,
            accNoOnAutoDebit: response.data?.data?.autoDebitDetailsBO?.accNoOnAutoDebit ? response.data?.data?.autoDebitDetailsBO?.accNoOnAutoDebit : "XXXXXXXXXXXX",
            platformIndicator: response.data?.data?.platformIndicator,
            inbFlag: response.data?.data?.inbFlag,
            partnerUUID: response.data?.data?.partnerUUID,
            yonoUUID: response.data?.data?.yonoUUID
          }
        });
      }
      dispatch({
        type: types.SAVE_TELCO_FLAGS_FOR_EKYC_JOURNEY, payload: {
          ekycJourneytelcoFLag: dataset['telcoFLag'],// saving telco flag to pass in kyc search for banka 
          ekycJourneytelcoReason: dataset['telcoReason']
        }
      });
      dispatch({
        type: types.SAVE_CKYC_DATA,
        payload: { applicationNumber: response.data.data?.applicationNumber, gender: response.data.data?.ckycGender },
      });
      if (response.data.data?.stpAddressList && response.data.data?.stpAddressList.length) {
        dispatch({
          type: types.SAVE_DIGILOCKER_DATA,
          payload: {
            gender: response.data.data?.kycGender,
            address: response.data.data?.stpAddressList ? response.data.data?.stpAddressList : null,
            document: response.data.data?.stpDocumenList ? response.data.data.stpDocumenList : null,
            kycValid: response.data.data?.kycValid,
            kycCompletedTimestamp: response.data.data?.kycCompletedTimeStamp ? response.data.data.kycCompletedTimeStamp : null
          },
        });
        dispatch({ type: types.SAVE_RESIADD_FLAGS, payload: { screenFlow: response.data.data?.stpAddressList[0]?.oclPinCodeFlag === true ? "manual" : user.state === "TR024" ? "digiSplitManual" : "digiAndManual" }, });
        dispatch({ type: types.SAVE_BRE_ASSISTED_FLAG, payload: { stpBreAssisted: response.data.data?.stpBreAssisted ? response.data.data?.stpBreAssisted : "" } });
        dispatch({ type: types.SAVE_FACE_TO_FACE_FLAG, payload: { faceToFace: response.data.data?.faceToFace ? response.data.data?.faceToFace : "" } });
      }
      else {
        dispatch({
          type: types.SAVE_DIGILOCKER_DATA,
          payload: { gender: response.data.data?.kycGender, address: null, document: null, kycValid: response.data.data?.kycValid, kycCompletedTimestamp: response.data.data?.kycCompletedTimeStamp ? response.data.data.kycCompletedTimeStamp : null },

        });
        dispatch({ type: types.SAVE_RESIADD_FLAGS, payload: { screenFlow: "manual" }, });
        dispatch({ type: types.SAVE_BRE_ASSISTED_FLAG, payload: { stpBreAssisted: response.data.data?.stpBreAssisted ? response.data.data?.stpBreAssisted : "" } });
        dispatch({ type: types.SAVE_FACE_TO_FACE_FLAG, payload: { faceToFace: response.data.data?.faceToFace ? response.data.data?.faceToFace : "" } });
      }

      if (user.state === "TR001") {
        let addr = getAddress(response.data.data?.stpAddressList, "CKYC");
        dispatch({
          type: types.SAVE_CKYC_DATA,
          payload: {
            applicationNumber: response.data.data?.applicationNumber,
            resiAddr: addr ? addr[0] : null,
            gender: response.data.data?.ckycGender,
            kin: response.data.data?.kin ? response.data.data.kin : "",
          }
        });
        if (!addr.length) {
          user.state = "TR002";
        }
      } else if (user.state === "TR003") {
        let addr = getAddress(response.data.data?.stpAddressList, "DEMOG");
        dispatch({ type: types.VALIDATE_OTP_CREATE_SSL, payload: { data: { resiAddr: addr } }, });
        if (addr.length) {
          dispatch({ type: types.SAVE_RESIADD_FLAGS, payload: { screenFlow: "demoAndManual" }, });
        } else {
          dispatch({ type: types.SAVE_RESIADD_FLAGS, payload: { screenFlow: "manual" }, });
        }
      }
      else if (getTrackState(user.state)) {
        if (response.data.data?.eligibleCardTypes || response.data.data?.finalCreditLimit || response.data.data?.posCreditLimit || response.data.data?.stpDocumenList) {

          let cardTypes = [];
          if (response.data.data?.eligibleCardTypes?.length) {
            response.data.data.eligibleCardTypes.map((cardType) => {
              const newCard = {
                "cardType": cardType,
                "feeValue": ""
              };
              return cardTypes = [...cardTypes, newCard];
            });
          }

          const data = {
            currentCardType: response.data.data?.currentCardType,
            eligibleCardTypes: cardTypes ? cardTypes : null,
            documents: response.data.data?.stpDocumenList,
            finalCreditLimit: parseInt(response.data.data?.posCreditLimit) ? response.data.data?.posCreditLimit : response.data.data?.finalCreditLimit,
            stpFlag: response.data.data?.stpFlag,
            vkycOptFlag: response.data.data?.vkycOptFlag,
            mitcOtpConsentDate: response.data.data?.mitcOtpConsentDate,
            vkycAgentDecisionReason: response.data.data?.vkycAgentDecisionReason ? (response.data.data?.vkycAgentDecisionReason).toUpperCase() : "",
            vkycAgentDecision: response.data.data?.vkycAgentDecision ? (response.data.data?.vkycAgentDecision).toUpperCase() : "",
            mitcOtpConsentTaken: response.data.data?.mitcOtpConsentTaken,
            stpBreAssisted: response.data.data?.stpBreAssisted ? response.data.data?.stpBreAssisted : "",
            faceToFace: response.data.data?.faceToFace ? response.data.data?.faceToFace : ""
          }
          dispatch({ type: types.SAVE_INGESTION2_RESPONSE, payload: data });
        }
        else if (user.state === "TR023") {
          const data = {
            currentCardType: response.data.data?.currentCardType,
            documents: response.data.data?.stpDocumenList,
            finalCreditLimit: parseInt(response.data.data?.posCreditLimit) ? response.data.data?.posCreditLimit : response.data.data?.finalCreditLimit,
            stpFlag: response.data.data?.stpFlag,
            vkycOptFlag: response.data.data?.vkycOptFlag,
            mitcOtpConsentDate: response.data.data?.mitcOtpConsentDate,
            vkycAgentDecisionReason: response.data.data?.vkycAgentDecisionReason ? (response.data.data?.vkycAgentDecisionReason).toUpperCase() : "",
            vkycAgentDecision: response.data.data?.vkycAgentDecision ? (response.data.data?.vkycAgentDecision).toUpperCase() : "",
            faceToFace: response.data.data?.faceToFace ? response.data.data?.faceToFace : ""
          }
          dispatch({ type: types.SAVE_INGESTION2_RESPONSE, payload: data });
        }
        if (response.data.data?.pennyDropDetails && response.data.data?.pennyDropDetails?.accountNumber) {
          dispatch({ type: types.IS_ACCOUNT_VALIDATION_FAILED, payload: false, });
        }
        if (user.state === "TR010") {
          user = { ...user, pennyCreditStatus: true };
          dispatch({
            type: types.ACCOUNT_VALIDATION, payload:
            {
              "nameMatch": response.data.data?.pennyDropDetails?.nameMatch && response.data.data?.pennyDropDetails?.nameMatch === "Y" ? true : false,
              "nameValidationByBD": true
            },
          });
        }
        else if (user.state === "TR008") {
          user = { ...user, pennyCreditStatus: true, pennyDebitStatus: true };
          if (response.data.data?.pennyDropDetails && response.data.data?.pennyDropDetails?.paymentIrn) {
            localStorage.setItem("paymentIrn", response.data.data.pennyDropDetails.paymentIrn);
          }
          dispatch({
            type: types.ACCOUNT_VALIDATION, payload:
            {
              "nameMatch": response.data.data?.pennyDropDetails?.nameMatch && response.data.data?.pennyDropDetails?.nameMatch === "Y" ? true : false,
              "nameValidationByBD": true
            },
          });
        }
      }
      else if (user.state === "ERR01" || user.state === "ERR02" || user.state === "ERR03" || user.state === "ERR04" || user.state === "ERR05" || user.state === "ERR06" || user.state === "ERR07" || user.state === "ERR08" || user.state === "ERR09" || user.state === "ERR10" || user.state === "ERR12" || user.state === "ERR13" || user.state === "ERR14" || user.state === "ERR15" || user.state === "ERR16") {
        dispatch({ type: types.SET_WIP_STATUS, payload: { errorCode: user.state }, });
        dispatch({
          type: types.GENERIC_ERROR,
          payload: { isGenericError: false, handleClick: null, exitEvent: null, errorMessage: "" },
        });
      }
      let data = {
        posRequired: response.data.data?.posRequired,
        surrogateStatus: response.data.data?.surrogateStatus,
        surrogateList: response.data.data?.surrogateList,
        posCreditLimit: response.data.posCreditLimit,
        finalCreditLimit: response.data.finalCreditLimit,
        gstnList: response.data.data.gstnList
      }
      dispatch({ type: types.SAVE_SURROGATE_DATA, payload: data });
      dispatch({ type: types.SAVE_PERSONAL_DETAILS, payload: user, });
      dispatch({ type: types.SAVE_BLAZESTP_ELIGIBLE, payload: response.data.data?.blazeStpEligible });
      if (response.data.data?.cardType && response.data.data?.cardType !== "")
        dispatch({ type: types.SAVE_NETWORK_CARDTYPE, payload: response.data.data?.cardType });
      const localHsToken = localStorage.getItem("hsToken");
      localStorage.setItem("hsToken", user?.hsToken ? user.hsToken : localHsToken ? localHsToken : "");
      payload = {
        ...initState,
        //isSubmited: true,
        isUserRetrieve: true,
        isSprintTrackRetrieve: true,
        loading: false,
      };
      errorState = null;
    }
    else if (statusCode === "006") {
      dispatch({ type: types.SAVE_NETWORK_CARDTYPE, payload: payload.dumpData.cardType });
      if (response.data.emvResponseDate)
        dispatch({ type: types.SAVE_CORP_OTP_VALIDATE_TIME, payload: response.data.emvResponseDate });
      payload = { ...initState, currentAction: "ValidateOTP", dataFilled: true, loading: false, };
      payload["isSubmitedSuccess"] = true;
      errorState = null;
    }
    else {
      payload = {
        ...initState,
        isSubmited: false,
        loading: false,
        isSubmitedSuccess: false,
        currentAction: action
      };
      errorState = {
        errorCode: response.data.statusCode,
        errorMsg: response.data.message,
      };

    }
  }
  else {
    payload = {
      ...initState,
      isSubmited: false,
      loading: false,
      isSubmitedSuccess: false,
      error: response.data?.message,
      currentAction: action
    };
    errorState = {
      errorCode: response.data.statusCode,
      errorMsg: response.data.message,
    };
  }
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
}

export const fetchDumpData = (empData, action) => async (dispatch) => {
  if (!empData?.isSprintDumpTrackRetrieve){
    dispatch({ type: types.LOADING_VIEW_STATE, value: true, });
  }  
  payload = {...initState,currentAction: action};
  const response = await DumpDataService.funcFetchDumpData(empData, action);
  if (response && response.data) {
    const statusCode = response.data.statusCode;
    if (statusCode === "000") {
      if (!empData?.isSprintDumpTrackRetrieve)
        payload = {
                ...payload,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: true,
            };
      else
          payload = { ...payload, isSprintDumpTrackRetrieve: true, isUserRetrieve: true, loading: false };
      errorState = null;
      const data = response.data.data;
      dispatch({
        type: types.SAVE_CORPORATE_DUMP_DATA, payload: data
      });
    } else if (statusCode === "101" || statusCode === "102") {
      const data = response.data.data;
      dispatch({
        type: types.SAVE_CORPORATE_DUMP_DATA, payload: data
      });
      payload = {
        ...initState,
        isSubmited: false,
        loading: false,
        isSubmitedSuccess: false,
        currentAction: action
      };
      errorState = {
        errorCode: response.data.statusCode,
        errorMsg: response.data.message,
      };
    }
    else {
      payload = {
        ...initState,
        isSubmited: false,
        loading: false,
        isSubmitedSuccess: false,
        currentAction: action
      };
      errorState = {
        errorCode: response.data.statusCode,
        errorMsg: response.data.message,
      };
    }
  } else {
    payload = {
      ...initState,
      isSubmited: false,
      loading: false,
      isSubmitedSuccess: false,
      error: response.data?.message,
      currentAction: action
    };
    errorState = {
      errorCode: response.data.statusCode,
      errorMsg: response.data.message,
    };
  }
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
};

export const funcCreateCorpSSL = (sslInputData, cardType, dumpData) => async (dispatch) => {
  dispatch({ type: types.LOADING_VIEW_STATE, value: true, });

  const response = await DumpDataService.funcCreateCorpSsl(sslInputData, cardType, dumpData);

  if (response.data.data?.shortCode && response.data.data?.shortCode !== "") {
    localStorage.setItem("shortCode", response.data.data.shortCode);
  }
  if (response && response.data) {
    const statusCode = response.data.statusCode;
    if (statusCode === "000" || statusCode === "001") {
      payload = { ...initState, currentAction: "ValidateOTP", dataFilled: true, loading: false, };
      payload["isSubmitedSuccess"] = true;
      dispatch({ type: types.VALIDATE_OTP_CREATE_SSL, payload: response.data, });
      errorState = null;
      // check for oauth token in the 
      if (response.data?.accessToken && response.data?.sbicUserFgp) {
        const resToken = { accessToken: response.data?.accessToken, cookie: response.data.sbicUserFgp, visitorId: response.data?.visitorID };
        GlobalService.setOAuthToken(resToken);
        SetTokenValues(resToken, true);
      }
      if (response.data.data?.cardType)
        dispatch({ type: types.SAVE_NETWORK_CARDTYPE, payload: response.data.data?.cardType });
    }
    else {
      payload = { ...initState, currentAction: "ValidateOTP", isSubmitedSuccess: false, dataFilled: false, loading: false, };
      errorState = { errorCode: response.data?.statusCode, errorMsg: response.data?.message, invalidOtpAttemptCount: response.data.data?.invalidOtpAttemptCount, };
    }
  }
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));


}

export const corpPanValidation = (panValidationData) => async (dispatch) => {
  dispatch({
    type: types.LOADING_VIEW_STATE,
    value: true,
  });
  const response = await DumpDataService.corpValidatePan(panValidationData);
  if (response && response.data) {
    const statusCode = response.data.statusCode;
    if (statusCode === "000" || statusCode === "002") {
      const panRes = {
        url: response.data?.data && response.data.data?.multicardOfferUrl ? response.data.data.multicardOfferUrl : "",
        gender: response.data?.data && response.data.data?.gender ? response.data.data.gender : "",
        visionAddress: response.data?.data && response.data?.data?.vPlusAddress ? response.data?.data?.vPlusAddress : null,
        visionMothersName: response.data?.data && response.data?.data?.vPlusMotherName ? response.data?.data?.vPlusMotherName : "",
        visionEmailId: response.data?.data && response.data?.data?.vPlusEmailId ? response.data?.data?.vPlusEmailId : "",
        dSignVPlusMotherName: response.data?.data && response.data?.data?.dSignVPlusMotherName ? response.data?.data?.dSignVPlusMotherName : "",
        dSignVPlusEmailId: response.data?.data && response.data?.data?.dSignVPlusEmailId ? response.data?.data?.dSignVPlusEmailId : "",
        dSignVPlusResiAddress: response.data?.data && response.data?.data?.dSignVPlusResiAddress ? response.data?.data?.dSignVPlusResiAddress : ""
        };
      let vArray = panRes?.visionAddress;
      let visionAdd = [];
      if (vArray && vArray.length > 0 && vArray != null) {
        visionAdd = getVisionAddress(vArray);
      }
      payload = {
        ...initState,
        isSaved: true,
        currentAction: "UpdatedPan",
        isSubmited: true,
        isSubmitedSuccess: true,
        loading: false,
        multicardUrl: panRes.url,
        gender: panRes.gender,
        vPlusResiAddress: visionAdd,
        visionMothersName: panRes.visionMothersName,
        visionEmailId: panRes.visionEmailId,
        dSignVPlusMotherName: panRes.dSignVPlusMotherName,
        dSignVPlusEmailId: panRes.dSignVPlusEmailId,
        dSignVPlusResiAddress: panRes.dSignVPlusResiAddress
      };
      dispatch(funcStoreMultiUrl(payload));
      dispatch(funcStoreVisionAddress(payload));
      errorState = null;
    }
    else {
      if (statusCode === "001") {
        const panResponse = {
          gender: response.data?.data && response.data.data?.gender ? response.data.data.gender : "",
          cureAfterDate: response.data?.data && response.data.data?.cureAfterDate ? response.data.data.cureAfterDate : "",
          applicationUpdatedDate: response.data?.data && response.data.data?.applicationUpdatedDate ? response.data.data.applicationUpdatedDate : "",
          applicationNumber: response.data?.data && response.data.data?.applicationNumber ? response.data.data.applicationNumber : "",
          applicationStatus: response.data?.data && response.data.data?.applicationStatus ? response.data.data.applicationStatus : "",
          hsToken: response.data?.data && response.data.data?.hsToken ? response.data.data.hsToken : "",
        };
        dispatch(funcStoreMultiUrl(panResponse));
      }

      payload = {
        ...initState,
        currentAction: "UpdatedPan",
        isSubmited: true,
        isSubmitedSuccess: false,
        loading: false,
      };
      errorState = {
        errorCode: response.data.statusCode,
        errorMsg: response.data.message,
      };
    }
  }
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
};

export const funcUpdateCorpSSL = (userDetail, action, currentAction, screenName) => async (dispatch) => {
  dispatch({ type: types.LOADING_VIEW_STATE, value: true, });
  let response;
  if (action === "ChangeNetwork") {
    let user = {
      cardType: userDetail.cardType,
      productType: userDetail?.productType,
      priority: userDetail.priority
    };
    response = await DumpDataService.funcUpdateCorpSSLByShortCodev1(user, "CorpupdateCard");
  } else {
    response = await DumpDataService.funcUpdateCorpSSLByShortCodev1(userDetail, action);
  }
  if (response && response.data) {
    const statusCode = response.data.statusCode;
    if (statusCode === "000" || statusCode === "001") {
      if (action === "ChangeNetwork") {
        payload = { ...initState, isSaved: false, isSubmited: false, isSubmitedSuccess: false, loading: false, currentAction: action };
        dispatch({ type: types.SAVE_SELECTED_NW_DATA, payload: userDetail });
      }
      else
        payload = { ...initState, isSaved: true, currentAction, isSubmited: true, isSubmitedSuccess: true, loading: false };

      if (userDetail.cardType) {
        dispatch({ type: types.SAVE_NETWORK_CARDTYPE, payload: userDetail.cardType });
      }
      // to update resi address from professional detail response
      if (action === "updateProfSubmit" && response.data.applicationNumber !== "") {
        dispatch({ type: types.SAVE_CKYC_DATA, payload: response.data.data, });
      }
      errorState = null;
    } else {
      if (response.data.data && response.data.data?.applicationNumber) {
        dispatch({ type: types.SAVE_CKYC_DATA, payload: { applicationNumber: response.data.data.applicationNumber }, });
      }
      if (action === "ChangeNetwork")
        payload = { ...initState, currentAction: "NwUpdFail", isSubmited: true, isSubmitedSuccess: false, loading: false, };
      else
        payload = { ...initState, currentAction, isSubmited: true, isSubmitedSuccess: false, loading: false, };
      errorState = { errorCode: response.data.statusCode, errorMsg: response.data.message, };
    }


  } else {
    payload = { ...initState, currentAction, isSubmited: true, isSubmitedSuccess: false, loading: false, error: response?.data?.message, };
    errorState = null;
  }
  dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
};